export enum enumCardStyle {
  DEFAULT,
  PRIMARY,
  SECONDARY,
  GRAY,
}
